import { render, staticRenderFns } from "./consumiveis.vue?vue&type=template&id=5ca2e226"
import script from "./consumiveis.vue?vue&type=script&lang=js"
export * from "./consumiveis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports